import React from "react";
import styled from "styled-components";
import { Button, Text } from "@origin-digital/ods-core";
import type { ISearchPaginationDto } from "../../contract/generated/bff/src/models";

const PaginationButton = styled(Button)`
  &.MuiButton-root {
    width: 40px;
    height: 40px;
    min-width: 0;
    padding: 0;
    border-radius: 50%;
  }
`;

const PaginationWrapper = styled("div")`
  display: grid;
  grid-auto-flow: column;
  width: fit-content;
  gap: 12px;
  padding-top: 48px;
  padding-left: 16px;
`;

interface SearchPaginationProps {
  pages: ISearchPaginationDto[];
  onSelect: (page: number) => void;
}

export const SearchPagination: React.FC<SearchPaginationProps> = ({
  pages,
  onSelect,
}) => {
  if (!pages.length) return null;

  return (
    <PaginationWrapper data-id="search-pagination">
      {pages.map((page) => (
        <PaginationButton
          key={page.page}
          variant={page.selected ? "contained" : "text"}
          size="small"
          color="secondaryB"
          onClick={() => onSelect(page.page)}
          data-id={`pagination-page-${page.page}`}
          aria-label={`Page ${page.page}`}
          aria-current={page.selected ? "page" : undefined}
        >
          <Text
            tone={page.selected ? "white" : "neutral"}
            variant="body"
            weight="medium"
          >
            {page.label}
          </Text>
        </PaginationButton>
      ))}
    </PaginationWrapper>
  );
};
